/**
 * 发票影像模块 store状态管理
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

import * as types from './../mutation-types'

const state = {
  invoiceInfo: {
    labels: []
  },
  //发票列表是否需要刷新
  invoiceIndexReload: {
    type: null, //  1  刷新某一条  一般是编辑后返回    ；2  刷新整个列表  一般用于添加新票据后 刷新
    reserve: '' //保留   当type = 1时候，存储的是票据id
  }
};

// 唯一改变状态的地方
const mutations = {
  [types.SET_INVOICE_INFO](state, newVal) {
    state.invoiceInfo = JSON.parse(JSON.stringify(newVal))
  },
  [types.UPDATE_INVOICE_TAGS](state, newVal) {
    state.invoiceInfo.labels = JSON.parse(JSON.stringify(newVal))
  },
  [types.SET_INVOICE_INDEX_RELOAD](state, newVal) {
    state.invoiceIndexReload = JSON.parse(JSON.stringify(newVal))
  }
};

// 包含异步操作(例如从后端拿到数据),
//改变状态必须commit   mutations去改变状态
//全局的  命名规范   模块名_ac_名称
const actions = {

  /**设置发票标签 */
  invoice_ac_setInvoiceTags({
    commit,
    rootState
  }, newVal) {
    commit(types.UPDATE_INVOICE_TAGS, newVal);
  },
  /**设置发票信息 */
  invoice_ac_setInvoiceInfo({
    commit,
    rootState
  }, newVal) {
    commit(types.SET_INVOICE_INFO, newVal);
  },
  /**设置发票列表是否需要刷新 */
  invoice_ac_setinvoiceIndexReload({
    commit,
    rootState
  }, newVal) {
    commit(types.SET_INVOICE_INDEX_RELOAD, newVal);
  }
};

// store里面的计算属性  全局的  命名规范   模块名_gt_名称
//模块名 加名称
const getters = {
  invoice_gt_invoiceTags(state, getters, rootState, rootGetters) {
    return state.invoiceInfo.labels;
  },
  invoice_gt_invoiceInfo(state, getters, rootState, rootGetters) {
    return state.invoiceInfo;
  },
  invoice_gt_invoiceIndexReload(state, getters, rootState, rootGetters) {
    return state.invoiceIndexReload;
  }

};

/**
 * actions, mutations, getters, 限定在当前模块的命名空间中。
 * 只要给我们的模块加一个namespaced 属性
 * 当所有的actions, mutations, getters
 * 都被限定到模块的命名空间下，我们dispatch actions,
 * commit mutations 都需要用到命名空间。
 * 如 dispacth("changeName"), 就要变成 dispatch("login/changeName");
 *  getters.localJobTitle 就要变成 getters["login/localJobTitle"]
 */
export default {
  // namespaced:true,  //这里不限定
  state,
  mutations,
  actions,
  getters
}

// export default {
//     state:{},
//     mutatons:{},
//     actions:{},
//     getters:{}
// }



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js